//import image
import { useEffect, useState } from "react"
import  {Link} from "react-router-dom" 

import { useMenuContext } from "../../../context/menuContext/MenuContext"

export default function Tab(props) {
  const daley = props.index * 0.3
  const animation = {
    animation: `slide-in-blurred-bottom  0.6s ${daley}s cubic-bezier(0.230, 1.000, 0.320, 1.000) both`,
  }
  const img = props.icon
  const { MenuPageIndex, SetMenuPageIndex } = useMenuContext()
  const [TabStyle, SetTabStyle] = useState(animation);

  useEffect(() => {
    if(MenuPageIndex === props.index){
      SetTabStyle({display: 'none'});
    }else{
      SetTabStyle(animation)
    }
  },[MenuPageIndex, SetMenuPageIndex])


  function StaticAnimation(){
      SetTabStyle({})
  }
  return (
    <Link to={props.path} className="Tab" style={TabStyle} onMouseOver={StaticAnimation} onMouseOut={StaticAnimation}>
      <div className="Icon">
        <img className="imgIcon Static" src={img.static} alt={props.title} />
        <img className="imgIcon Hover" src={img.hover} alt={props.title} />
      </div>
      <span className="Label">
        {props.title}
      </span>

    </Link>
  );
}
